import { render, staticRenderFns } from "./navbar-notifications-icon.vue?vue&type=template&id=2228e9a8&scoped=true"
import script from "./navbar-notifications-icon.vue?vue&type=script&lang=ts"
export * from "./navbar-notifications-icon.vue?vue&type=script&lang=ts"
import style0 from "./navbar-notifications-icon.vue?vue&type=style&index=0&id=2228e9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228e9a8",
  null
  
)

export default component.exports